// Client-side: which story lengths this visitor is offered, from /api/geo. Fetched once per page load and shared by
// every remount of the wizard step, so a low-price visitor's chosen 8 is never judged against the [16, 24] fallback.
import { allowedStoryPageCounts } from './page-length-policy';
import { __resetClientGeoForTests, fetchClientGeo } from '@/lib/geo/client-geo';

let resolved: number[] | null = null;
let inflight: Promise<number[]> | null = null;

/** The resolved list, or null while /api/geo has not answered yet. */
export function getResolvedStoryPageCounts(): number[] | null {
  return resolved;
}

/** Resolves to the offered lengths; any fetch failure resolves to the non-low-price list [16, 24]. */
export function loadStoryPageCounts(fetchFn: typeof fetch = fetch): Promise<number[]> {
  if (resolved) return Promise.resolve(resolved);
  if (!inflight) {
    inflight = fetchClientGeo(fetchFn) // the same /api/geo request utils/countryDetection.ts uses
      .then((geo) => allowedStoryPageCounts(typeof geo?.country === 'string' ? geo.country : null))
      .catch(() => allowedStoryPageCounts(null))
      .then((counts) => {
        resolved = counts;
        return counts;
      });
  }
  return inflight;
}

export function __resetStoryPageCountsForTests() {
  resolved = null;
  inflight = null;
  __resetClientGeoForTests();
}
